import { IncentiveApiData } from '../types/IncentivesDataType';
import Item from '../types/ItemType';
import { DropdownConstants } from '../constants/DropdownConstants';
import { WeightClass } from '../types/WeightClass';
import { sortAndFormatDropdownValues } from './SortFormatDropdownUtils';

export const getUniqueEligibleOrganizations = (incentives: IncentiveApiData[]): Item[] => {
    const eligibleOrganizationsSet = new Set<string>();
    eligibleOrganizationsSet.add(DropdownConstants.ALL);

    incentives.forEach((incentive) => {
        incentive.eligibleOrganizations.split(',').forEach((org: string) => {
            eligibleOrganizationsSet.add(org.trim());
        });
    });
    return sortAndFormatDropdownValues(Array.from(eligibleOrganizationsSet));
};

export const getUniqueCurrentProgramStatuses = (incentives: IncentiveApiData[]): Item[] => {
    const currentProgramStatusesSet = new Set<string>();
    currentProgramStatusesSet.add(DropdownConstants.ALL);

    incentives.forEach((incentive) => {
        const status = incentive.currentProgramStatus?.trim();
        if (status) {
            currentProgramStatusesSet.add(status);
        }
    });
    return sortAndFormatDropdownValues(Array.from(currentProgramStatusesSet));
};

export const getUniqueEligibleEquipments = (incentives: IncentiveApiData[]): Item[] => {
    const eligibleEquipmentSet = new Set<string>();
    eligibleEquipmentSet.add(DropdownConstants.ALL);

    incentives.forEach((incentive) => {
        if (Array.isArray(incentive.eligibleEquipment)) {
            incentive.eligibleEquipment.forEach((equipment) => {
                eligibleEquipmentSet.add(equipment.trim());
            });
        }
    });
    return sortAndFormatDropdownValues(Array.from(eligibleEquipmentSet));
};

export const getVehicleModels = (): WeightClass[] => {
    return [
        {
            label: 'E-Transit',
            value: '2',
        },
        {
            label: 'F-150 Lightning',
            value: '2repeated',
        },
        {
            label: 'Mustang Mach-E',
            value: '1',
        },
    ];
};

export const getUniqueEligibleChargingTechnology = (incentives: IncentiveApiData[]): Item[] => {
    const eligibleChargingTechnologySet = new Set<string>();
    eligibleChargingTechnologySet.add(DropdownConstants.ALL);
    incentives.forEach((incentive) => {
        if (
            incentive.eligibleChargingTechnology !== null &&
            incentive.eligibleChargingTechnology.includes(',')
        ) {
            incentive.eligibleChargingTechnology.split(',').forEach((org: string) => {
                eligibleChargingTechnologySet.add(org.trim());
            });
        }
    });
    return sortAndFormatDropdownValues(Array.from(eligibleChargingTechnologySet));
};
